import React from "react";
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { ConfigProvider, notification, Button } from 'antd';

import "./App.css";
import "./config/GlobalData"; // 全局变量配置文件

import moment from "moment";
import I18n from "./language/I18n";
import ModelManager from "./domain/ModelManager";
import AppStatus from "./domain/AppStatus";
import { getRemember, getDefaultLang, saveDefaultLang, getLoginTime, clearRemember } from "./utils/Session";
import PrivateRoute from "./components/PrivateRoute/privateRoute";
import Routes from "./routes";
import config from "./config";
import Net from "./utils/net";
import Login from "./pages/login";
import ViewImage from "./pages/view";

global.openNotification = (info) => {
	const key = `${info.type}${Date.now()}`;
	const btn = (
		<Button onClick={() => notification.close(key)} type="primary" size="small">
			{info.btnString || I18n.t("关闭")}
		</Button>
	);
	notification[info.type]({
		message: info.message || "",
		description: info.description || "",
		duration: 0,
		key,
		btn,
		onClick: () => {
			// console.log('Notification Clicked!');
		},
	});
};

document.onkeydown = function (event) {
	// return;
	var e = event || window.event || arguments.callee.caller.arguments[0];
	if (e && e.keyCode == 27) { // 按 Esc 
		//要做的事情
	}
	if (e && e.keyCode == 113) { // 按 F2 
		//要做的事情
	}
	if (e && e.keyCode == 13) { // enter 键
		//要做的事情
	}
	if (e && e.keyCode == 8) { // backSpace键
		stopBack(e)
	}
};

// 禁止点击backspace 返回上一页
function stopBack(event) {
	//获取事件对象
	var elem = event.relatedTarget || event.srcElement || event.target || event.currentTarget;

	//获取按键按下时光标做指向的element
	var elem = event.srcElement || event.currentTarget;

	//判断是否需要阻止按下键盘的事件默认传递
	var name = elem.nodeName;
	if (name != 'INPUT' && name != 'TEXTAREA') {
		return _stopIt(event);
	}
	var type_e = elem.type.toUpperCase();
	// console.log("stopBack", name, type_e)
	if (name == 'INPUT' && (type_e != 'TEXT' && type_e != 'SEARCH' && type_e != 'TEXTAREA' && type_e != 'PASSWORD' && type_e != 'FILE')) {
		return _stopIt(event);
	}
	if (name == 'INPUT' && (elem.readOnly == true || elem.disabled == true)) {
		return _stopIt(event);
	}
}

function _stopIt(e) {
	if (e.returnValue) {
		e.returnValue = false;
	}
	if (e.preventDefault) {
		e.preventDefault();
	}

	return false;
}

export default class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			locale: global.zhCN,
		};

		global.loadBaseInfo = this.loadData.bind(this);
		global.reloadBaseInfo = this.reloadBaseInfo.bind(this);
		global.reloadInTime = this.reloadInTime.bind(this);
		global.loadAllAccessory = this.loadAllAccessory.bind(this);
		global.loadProducts = this.loadProducts.bind(this);
		global.loadIris = this.loadIris.bind(this);
		global.loadAllWorkScope = this.loadAllWorkScope.bind(this);
		global.clearAppInterval = this.clearAppInterval.bind(this);
		global.reLoginInterval = this.reLoginInterval.bind(this);
		global.loadRegions = this.loadRegions.bind(this);
		global.loadStores = this.loadStores.bind(this); // 门店列表
		global.loadEmergency = this.loadEmergency.bind(this);
		global.loadComplainUnHandle = this.loadComplainUnHandle.bind(this);
		global.getSortingAppCountByStatus = this.getSortingAppCountByStatus.bind(this);
		global.getDismantleAppCountByStatus = this.getDismantleAppCountByStatus.bind(this);
		global.getCheckoutAppCountByStatus = this.getCheckoutAppCountByStatus.bind(this);
		global.getAppStatus = this.getAppStatus.bind(this);
		global.goToLogin = this.goToLogin.bind(this);
		global.setLang = this.setLang.bind(this);
	};
	UNSAFE_componentWillMount() {
	}
	componentDidMount() {
		console.log("window.location.href", window.location.href, global.isDev)
		this.setLang();
		this.reloadInterval && clearInterval(this.reloadInterval);
		this.reloadInterval = setInterval(() => {
			this.reloadInTime();
		}, 60 * 60 * 1000)
		this.onCheckLogin();
	}
	componentWillUnmount() {
		global.clearAppInterval && global.clearAppInterval();
	}
	onCheckLogin = () => {
		const autoLogin = global.isDev ? config.autoLogin.dev : config.autoLogin.pro;
		let rememberMe = getRemember();
		global.lastLoginTime = getLoginTime();
		console.log("App rememberMe", rememberMe, autoLogin)
		if (rememberMe && rememberMe.autoLogin && rememberMe.user && autoLogin) {
			let isReLogin = this.reLogin();
			console.log("reLogin isReLogin", isReLogin)
			console.log("reLogin rememberMe.user", rememberMe.user)
			if (!isReLogin) {
				global.loginUser = rememberMe.user;
				ModelManager.loginUser = rememberMe.user;
				if (rememberMe.user.regionInfo) {
					ModelManager.region = rememberMe.user.regionInfo;
				}
				if (ModelManager.loginUser.token) {
					window.token = ModelManager.loginUser.token;
				}
				global.EE.emitEvent("LOAD_USERINFO", [global.loginUser]);
				global.EE.emitEvent("LOAD_DB_NAME");
				this.loadData();
				this.reloadInTime();
				this.reLoginInterval();
				global.startGetRoutesData && global.startGetRoutesData();
			}
			// this.loadEmergency();
			this.renewToken();
		} else {
			console.log("goToLogin111")
			this.goToLogin();
		}
	}

	reLoginInterval = () => {
		this.logoutTimer && clearInterval(this.logoutTimer);
		this.logoutTimer = setInterval(() => {
			this.reLogin();
		}, 1000 * 60)
	};
	reLogin = () => {
		const today = moment().format("YYYY-MM-DD");
		if (!global.lastLoginTime || global.lastLoginTime !== today) {
			console.log("goToLogin reLogin")
			this.goToLogin();
			return true;
		}
		return false;
	};

	goToLogin = () => {
		console.log("goToLogin window.location.href", window.token, window.location.href, window.location.href.includes("view?id="))
		if (window.location.href.includes("view?id=")) {
			return;
		}
		clearRemember();
		if (global.lang) {
			saveDefaultLang(global.lang);
		}
		let url = global.delParam("token");
		url = url.substring(0, url.indexOf("#"));
		if (!url.includes('login')) {
			window.location.href = url + '#/login';
		}
		global.clearAppInterval && global.clearAppInterval();
		global.clearRoutesInterval && global.clearRoutesInterval();
	};

	setLang = () => {
		let lang = getDefaultLang();
		console.log('setLang Language:', lang);
		let { locale } = this.state;
		if (lang === "zh_HANT") {
			locale = global.zhHK;
			global.DateLocal = global.zhHK;
		} else if (lang === "en_US") {
			locale = global.enUS;
			global.DateLocal = global.enUS;
		} else {
			locale = global.zhCN;
			global.DateLocal = global.zhCN;
		}
		global.lang = lang;
		I18n.setLanguage(lang);
		this.setState({ locale, lang });
	};

	// 需要定时查询的数据
	reloadInTime = () => {
		console.log("reloadInTime")
		this.loadStaffs();
		this.reloadBaseInfo();
		this.loadEmergency();
		this.getAppStatus();
	};

	reloadBaseInfo = () => {
		this.loadRegions();
		this.loadProducts();
		this.loadAllAccessory();
		this.loadIris();
		this.loadStores();
	}

	// 需要查询的基础数据
	loadData = () => {
		this.loadOrgs();
		this.loadRegions();
		this.loadStaffs();
		this.loadProducts();
		this.loadAllAccessory();
		this.loadIris();
		this.loadStores();
		this.getMailSetting();
		// if (!global.isHK) {
		this.loadAllWorkScope();
		// }
	};

	getAppStatus = () => {
		this.getSortingAppCountByStatus();
		this.getDismantleAppCountByStatus();
		this.getCheckoutAppCountByStatus();
		this.getCheckoutAppCountByStatus("DISMANTLE");
	}

	clearAppInterval = () => {
		this.logoutTimer && clearInterval(this.logoutTimer);
		this.reloadInterval && clearInterval(this.reloadInterval);
	};

	loadAllWorkScope = () => {
		let url = global.ServerUrl + "workScope/list";
		Net.post(url, {}, (res) => {
			if (res.result === 0) {
				ModelManager.workScopeList = res.ret;
				ModelManager.workScopeMap = {
					[AppStatus.STATISTIC_EPIDEMIC]: {},
					[AppStatus.STATISTIC_HOLIDAY]: {},
				}
				if (res.ret.length > 0) {
					res.ret.forEach(item => {
						if (item.type === AppStatus.STATISTIC_EPIDEMIC) {
							ModelManager.workScopeMap[item.type][item.regionId] = item;
						} else {
							ModelManager.workScopeMap[item.type][item.regionId] = ModelManager.workScopeMap[item.type][item.regionId] || [];
							ModelManager.workScopeMap[item.type][item.regionId].push(item);
						}
					});
					// console.log("workScopeMap STATISTIC_EPIDEMIC", ModelManager.workScopeMap[AppStatus.STATISTIC_EPIDEMIC])
					// console.log("workScopeMap STATISTIC_HOLIDAY", ModelManager.workScopeMap[AppStatus.STATISTIC_HOLIDAY])
				}
			}
		}, error => {
			console.log("loadAllWorkScope", error)
		})
	};

	getStaffById = () => {
		let url = `${global.ServerUrl}staff/${ModelManager.loginUser.id}`;
		Net.get(url, (res) => {
			console.log("getStaffById", res);
			if (res.result === 0) {
				const userInfo = res.ret;
				const regionInfo = res.region;
			}
		}, error => {
			console.log("getStaffById", error);
		})
	}

	renewToken = () => {
		// if (global.isDev) return;
		let url = global.ServerUrl + "staff/renewToken";
		console.log("renewToken global.loginUser", global.loginUser);
		if (!global.loginUser || !global.loginUser.token) {
			console.log("goToLogin renewToken")
			return this.goToLogin();
		}
		Net.post(url, { token: global.loginUser.token }, (res) => {
			console.log("renewToken res", res);
			if (res.result === 0) {
				const element = res.ret;
			} else {
				console.log("goToLogin renewToken2")
				this.goToLogin();
			}
		}, error => {
			console.log("renewToken", error);
		})
	}

	getMailSetting = () => {
		let url = global.ServerUrl + "mailSetting";
		Net.get(url, (res) => {
			// console.log("getMailSetting", res);
			if (res.result === 0) {
				ModelManager.mailSetting = res.ret;
			}
		}, error => {
			console.log("getMailSetting", error);
		})
	};

	loadEmergency = () => {
		if (ModelManager.loginUser == null) return;
		let url = global.ServerUrl + "fixApp/emergency";
		Net.post(url, { staff: ModelManager.loginUser }, (res) => {
			console.log("loadEmergency", res);
			if (res.result === 0) {
				global.emergencyList = res.ret;
				global.EE.emitEvent("HAS_EMERGENCY", [true]);
			} else {
				global.emergencyList = [];
				global.EE.emitEvent("HAS_EMERGENCY", [false]);
			}
		}, error => {
			console.log("loadEmergency", error);
			global.emergencyList = [];
			global.EE.emitEvent("HAS_EMERGENCY", [false]);
		})
	};

	loadComplainUnHandle = () => {
		let url = global.ServerUrl + "fixApp/complainUnHandle";
		Net.post(url, { staff: ModelManager.loginUser }, (res) => {
			console.log("loadComplainUnHandle", res);
			if (res.result === 0) {
				global.complainList = res.ret;
				global.EE.emitEvent("HAS_COMPLAIN", [true]);
			} else {
				global.complainList = [];
				global.EE.emitEvent("HAS_COMPLAIN", [false]);
			}
		}, error => {
			console.log("loadComplainUnHandle", error);
			global.complainList = [];
			global.EE.emitEvent("HAS_COMPLAIN", [false]);
		})
	};
	// 根据员工职务查询待审核/待审批分拣单数量
	getSortingAppCountByStatus = () => {
		if (ModelManager.loginUser == null) return;
		const url = global.ServerUrl + "SortingApp/getCountByStatus";
		let data;
		if (ModelManager.userIsZB()) {
			if (ModelManager.isAssistant()) { // 维修部助理
				data = { status: AppStatus.S_SORT_TOBEAUDIT };
			}
			if (ModelManager.isManager()) { // 维修部经理
				data = { status: AppStatus.S_SORT_TOBEAGREE };
			}
		}
		console.log("getSortingAppCountByStatus data", data)
		if (!data) return global.EE.emitEvent("SHOW_SORT_TIP", [false]);
		Net.post(url, data, (res) => {
			console.log("getSortingAppCountByStatus res", res)
			if (res.result === 0 && res.ret > 0) {
				global.EE.emitEvent("SHOW_SORT_TIP", [true]);
			} else {
				global.EE.emitEvent("SHOW_SORT_TIP", [false]);
			}
		}, error => {
			console.log("getSortingAppCountByStatus", error)
			global.EE.emitEvent("SHOW_SORT_TIP", [false]);
		});
	}
	getDismantleAppCountByStatus = () => {
		if (ModelManager.loginUser == null) return;
		const url = global.ServerUrl + "DismantleApp/getCountByStatus";
		let data;
		if (ModelManager.userIsZB()) {
			if (ModelManager.isAssistant() && ModelManager.dismantleAuditAuth()) { // 维修部助理
				data = { status: AppStatus.S_DISMANTLE_TOBEAUDIT };
			}
			if (ModelManager.isManager()) { // 维修部经理
				data = { status: AppStatus.S_DISMANTLE_TOBEAGREE };
			}
		}
		console.log("getDismantleAppCountByStatus data", data)
		if (!data) return global.EE.emitEvent("SHOW_DISMANTLE_TIP", [false]);
		Net.post(url, data, (res) => {
			console.log("getDismantleAppCountByStatus res", res)
			if (res.result === 0 && res.ret > 0) {
				global.EE.emitEvent("SHOW_DISMANTLE_TIP", [true]);
			} else {
				global.EE.emitEvent("SHOW_DISMANTLE_TIP", [false]);
			}
		}, error => {
			console.log("getDismantleAppCountByStatus", error)
			global.EE.emitEvent("SHOW_DISMANTLE_TIP", [false]);
		});
	}
	// 根据员工职务查询待审核/待审批结账单数量
	getCheckoutAppCountByStatus = (code) => {
		if (ModelManager.loginUser == null) return;
		const url = global.ServerUrl + "checkoutApp/getCountByStatus";
		const emitKey = code === "DISMANTLE" ? "SHOW_DISMANTLE_CHECKOUT_TIP" : "SHOW_CHECKOUT_TIP";
		let data;
		if (ModelManager.userIsZB() && (ModelManager.isAssistant() || ModelManager.isManager() || ModelManager.userIsZBAdmin())) {
			data = { staff: ModelManager.loginUser };
			if (code === "DISMANTLE") {
				data.from = "DISMANTLE";
			}
		}
		console.log("getCheckoutAppCountByStatus data", data)
		if (!data) return global.EE.emitEvent(emitKey, [false]);
		Net.post(url, data, (res) => {
			console.log("getCheckoutAppCountByStatus res", res)
			if (res.result === 0 && res.ret > 0) {
				global.EE.emitEvent(emitKey, [true]);
			} else {
				global.EE.emitEvent(emitKey, [false]);
			}
		}, error => {
			console.log("getCheckoutAppCountByStatus", error)
			global.EE.emitEvent(emitKey, [false]);
		});
	}
	loadOrgs = () => {
		global.org = {};
		let url = global.ServerUrl + "org/list";
		Net.post(url, null, (res) => {
			console.log("loadOrgs", res);
			if (res.result === 0) {
				ModelManager.OrgList = res.ret;
				if (res.ret && res.ret.length > 0) {
					global.org = res.ret[0];
				}
			}
		}, error => {
			console.log("loadOrgs", error);
		})
	};

	loadRegions = (callback) => {
		let url = global.ServerUrl + "region/list";
		Net.post(url, null, (res) => {
			// console.log("loadRegions", res)
			if (res.result === 0) {
				res.ret.sort(function (a, b) {
					return a.name.localeCompare(b.name, 'zh-CN');
				})
				if (callback) {
					return callback(res.ret);
				}
				ModelManager.RegionList = res.ret;
				global.setRegions && global.setRegions(res.ret);
			}
		}, error => {
			console.log("loadRegions", error)
		})
	};

	loadStaffs = () => {
		let url = global.ServerUrl + "staff/list";
		Net.post(url, null, (res) => {
			console.log("loadStaffs res", res)
			if (res.result === 0) {
				ModelManager.staffList = res.ret;
			}
		}, error => {
			console.log("loadStaffs", error)
		})
	};

	loadProducts = () => {
		let url = global.ServerUrl + "product/list";
		Net.post(url, null, (res) => {
			console.log("loadProducts", res)
			if (res.result === 0) {
				ModelManager.productList = res.ret;
				for (let i = 0; i < ModelManager.productList.length; i++) {
					const elem = ModelManager.productList[i];
					ModelManager.productMap[elem.model] = elem;
					ModelManager.productMap[(elem.model).toUpperCase()] = elem;
					ModelManager.productMapUnifiedModel[(elem.unifiedModel).toUpperCase()] = elem;
				}
				console.log("loadProducts ModelManager.productMap", ModelManager.productMap)
				console.log("loadProducts ModelManager.productMapUnifiedModel", ModelManager.productMapUnifiedModel)
			}
		}, error => {
			console.log("loadProducts", error);
		})
	}

	getProductUnifiedModels = () => {
		console.log('getProductUnifiedModels')
		const url = global.ServerUrl + "product/unifiedModels";
		Net.post(url, {}, (res) => {
			console.log('getProductUnifiedModels', res)
			if (res.result === 0) {
				ModelManager.productUnifiedModels = res.ret;
			} else {
				ModelManager.productUnifiedModels = []
			}
		}, error => {
			ModelManager.productUnifiedModels = []
			console.log("getProductUnifiedModels", error);
		})
	}

	loadAllAccessory = () => {
		let url = global.ServerUrl + "accessory/list";
		Net.post(url, null, (res) => {
			if (res.result === 0) {
				ModelManager.accessoryList = res.ret;
				for (let i = 0; i < ModelManager.accessoryList.length; i++) {
					const elem = ModelManager.accessoryList[i];
					ModelManager.accessoryMap[elem.code] = elem;
					ModelManager.accessoryMap[(elem.code).toUpperCase()] = elem;
				}
			}
		}, error => {
			console.log("loadAllAccessory", error);
		})
	};
	loadIris = () => {
		let url = global.ServerUrl + "iris/list";
		let query = {
			offset: 0,
			limit: 1000,
		};
		Net.post(url, query, (res) => {
			console.log("loadIris", res)
			if (res.result === 0) {
				ModelManager.IrisCodeList = res.ret;
			}
		}, error => {
		})
	};

	loadStores = () => {
		const url = global.ServerUrl + "Stores/list";
		Net.post(url, null, (res) => {
			console.log("loadStores", res)
			if (res.result === 0) {
				ModelManager.storeList = res.ret;
				for (let i = 0; i < ModelManager.storeList.length; i++) {
					const elem = ModelManager.storeList[i];
					ModelManager.storeMap[elem.name] = elem;
				}
			}
		}, error => {
			console.log("loadStores", error)
		})
	};

	render() {
		const { locale } = this.state;
		return (
			<ConfigProvider locale={locale}>
				<Router>
					<Switch>
						<Route path="/login" component={Login} />
						<Route path="/view" component={ViewImage} />
						{/* <Route path="/home" component={Home} /> */}
						<PrivateRoute path="/sys" component={Routes} />
						<Redirect exact from="/" to="/login" />
					</Switch>
				</Router>
			</ConfigProvider>
		)
	}
}


